import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import StateTree from "./StateTree";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";

function fetchSessionVariable(dataPool, sessionKey, sessionVariable) {
    try {
        if (!dataPool || !sessionKey || !sessionVariable) return null;

        const sessionData = dataPool[sessionKey];

        if (!sessionData) return null;

        if (sessionVariable.includes(".")) {
            const keySplit = sessionVariable.split(".");
            const initialKey = keySplit[0];

            let newKey = "";

            for (let i = 1; i < keySplit.length; i++) {
                newKey += keySplit[i];
            }

            return fetchSessionVariable(sessionData, initialKey, newKey);
        }

        const sessionValue = sessionData[sessionVariable];

        return sessionValue;
    } catch (e) {
        console.log(e);
    }
}

async function fetchSessionAll({ sessionId }) {
    try {
        const results = await Express.call("fetch-session", {
            sessionId,
        });

        if (!results) return;

        const sessionKeys = Object.keys(results);

        for (let i = 0; i < sessionKeys.length; i++) {
            const sessionKey = sessionKeys[i];
            const sessionData = results[sessionKey];

            StateTree.update(sessionKey, sessionData);
        }
    } catch (e) {
        console.log(e);
    }
}

function createSessionProcesses() {
    try {
        const globalMessage = window.localStorage.getItem("globalMessage");

        if (globalMessage) {
            toast.success(globalMessage);
            window.localStorage.removeItem("globalMessage");
        }

        const sessionId = window.sessionStorage.getItem("sessionId");

        if (!sessionId) return;

        fetchSessionAll({ sessionId });

        let origin = window.location.origin;

        if (origin.includes("localhost")) {
            origin = origin.replace(":1234", ":3000");
        }

        origin = origin.replace("http:", "ws:");
        origin = origin.replace("https:", "wss:");

        const websocket = new WebSocket(
            origin + "/websockets?sessionId=" + sessionId
        );
        websocket.connectionId = sessionId;

        websocket.onmessage = function (event) {
            if (event.data) {
                try {
                    const decodedMessage = decode(
                        event.data,
                        event.target.connectionId.substring(0, 32)
                    );

                    const messageObject = JSON.parse(decodedMessage);

                    const { key, sessionData } = messageObject;
                    if (key && sessionData) {
                        StateTree.update(key, sessionData);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        };

        Express.call("validate-session", { sessionId });
    } catch (e) {
        console.log(e);
    }
}

const matchingFuctions = {
    eq: equalMatch,
    in: includesMatch,
    lower: lowerMatch,
    lte: lessThanOrEqual,
    gte: greaterThanOrEqual,
};

function sessionVariableMatch(sessionVariable, key, value, match) {
    try {
        if (!sessionVariable || !key || !value) return false;

        const sessionData = sessionVariable[key];

        match = match || "eq";

        const matchFunction = matchingFuctions[match];

        return matchFunction(sessionData, value);
    } catch (e) {
        console.log(e);
        return false;
    }
}

function equalMatch(base, check) {
    return base === check;
}

function includesMatch(base, check) {
    return base.includes(check);
}

function lowerMatch(base, check) {
    return base.toLowerCase() === check.toLowerCase();
}

function lessThanOrEqual(base, check) {
    return base <= check;
}

function greaterThanOrEqual(base, check) {
    return base >= check;
}

function decode(input, key) {
    try {
        var keys = CryptoJS.enc.Utf8.parse(key);
        let base64 = CryptoJS.enc.Base64.parse(input);
        let src = CryptoJS.enc.Base64.stringify(base64);
        var decrypt = CryptoJS.AES.decrypt(src, keys, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });

        return decrypt.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        console.log(e);
        return input;
    }
}

export {
    fetchSessionVariable,
    fetchSessionAll,
    createSessionProcesses,
    sessionVariableMatch,
};
